import { combineReducers } from 'redux';
import locales from './locales/locales';
import chartControls from './simulations/chart-controls';

export default combineReducers({
  locales,
  chartControls,
});
